import React from "react";
// @ts-ignore
import { Col, Row, Table } from "reactstrap";

function Entities(props: { entities?: any[] }) {
  if (!props.entities || props.entities.length === 0) {
    return null;
  }

  return (
    <Row>
      <Col xs={10}>
        <Table hover bordered responsive size={'sm'} className={'entities-table'}>
          <thead>
            <tr>
              <th>Entities</th>
              <th>Value</th>
              <th>Confidence</th>
            </tr>
          </thead>
          <tbody>
            {props.entities.map((entity: any) => (
              <tr key={entity.id}>
                <td>{entity.name}</td>
                <td>{entity.value}</td>
                <td>{entity.confidence * 100}%</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Col>
    </Row>
  )
}

export default Entities;
